var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tree-form-box"},[_c('div',{staticClass:"tree-form-tree"},[_vm._t("tree")],2),_c('div',{staticClass:"tree-form-form-box"},[_c('div',{staticClass:"btn-group"},[_vm._t("btn-group")],2),_c('div',{staticClass:"tree-form-form"},[_vm._t("form")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }